import styled from "styled-components";
import { Color, breakpoints, ColorDark } from "@/shared/Constants";

export const StarList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 0.2rem;

  .stars {
    display: flex;
  }
  span.active svg {
    fill: ${Color.grey};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        fill: ${ColorDark.greySeparator} !important;
      }
    }
  }
  span.empty svg {
    fill: ${Color.greyE2E2E2};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        fill: ${ColorDark.greySeparator} !important;
      }
    }
  }
  .filled {
    svg {
      fill: #555555 !important;
      ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        fill: ${ColorDark.textLight} !important;
      }
    }
    }
  }

  .half {
    svg {
      fill: rgb(145, 142, 142) !important;
    }
  }

  .empty {
    svg {
      fill: #dcdcdc !important;
    }
  }

`;
